import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { LessonCard } from './LessonCard';

export function Rail({ title, subtitle, lessons = [], action }) {
  const ref = useRef(null);
  if (!lessons.length) return null;

  const scroll = (dir) => {
    ref.current?.scrollBy({ left: dir * 560, behavior: 'smooth' });
  };

  return (
    <section className="space-y-3">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-semibold text-white">{title}</h2>
          {subtitle && <p className="text-sm text-zinc-500">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2">
          {action}
          <button
            onClick={() => scroll(-1)}
            className="grid h-9 w-9 place-items-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-white/30 hover:text-white"
            aria-label="Scroll left"
            data-testid={`rail-left-${title}`}
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={() => scroll(1)}
            className="grid h-9 w-9 place-items-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-white/30 hover:text-white"
            aria-label="Scroll right"
            data-testid={`rail-right-${title}`}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
      <div ref={ref} className="no-scrollbar flex gap-4 overflow-x-auto pb-2">
        {lessons.map((l, i) => (
          <LessonCard key={l.lesson_id} lesson={l} index={i} compact />
        ))}
      </div>
    </section>
  );
}
